import { useEffect, useState } from "react";
import ChildComponent from "./ChildComponent";
import UploadFiles from "./uploadfiles";
import gtmLogo from "../logos/gtm-logo.png";
import homeIcon from "../logos/home.png";
import bookIcon from "../logos/book_4_spark.png";
import historyIcon from "../logos/cycle.png";
import newChatIcon from "../logos/new chat.png";
// import LoginPopup from './LoginPopup';
import CopyRightIcon from "../logos/copyright";
import Cookie from "js-cookie";

interface Message {
  user: string;
  text: string;
}

const ParentComponent = () => {
  const [activeComponent, setActiveComponent] = useState("chat"); // 'chat' or 'upload'
  const [newChat, setNewChat] = useState(true);
  const [messages, setMessages] = useState<{
    [key: string]: Message[];
  }>({});
  // Generate a unique threadId on each page refresh to ensure fresh chat sessions
  const [threadId, setThreadId] = useState(() => Date.now());
  const [selectedThread, setSelectedThread] = useState<number | null>(null);
  const [messagesOfSelectedThread, setMessagesOfSelectedThread] = useState<
    Message[]
  >([]);

  console.log("messages history", messages);

  useEffect(() => {
    const history = Cookie.get("history");
    if (history) {
      setMessages(JSON.parse(history));
    }
  }, []);

  const handleKnowledgeBaseClick = () => {
    setActiveComponent("upload");
  };

  const handleHomeClick = () => {
    setActiveComponent("chat");
    setNewChat(true);
    // Generate a new unique threadId for each new chat
    const newThreadId = Date.now();
    setThreadId(newThreadId);
    setMessagesOfSelectedThread([]);
  };

  const updateNewChatValue = () => {
    setNewChat(false);
  };

  // Add handler for thread selection
  const handleThreadSelect = (threadId: number) => {
    setSelectedThread(threadId);
    setThreadId(threadId);
    setActiveComponent("chat");
    setNewChat(false);
    setMessagesOfSelectedThread(messages[threadId]);
  };

  return (
    <div className="flex h-screen w-screen font-sans overflow-hidden bg-[#f2f4f9]">
      {/* Sidebar */}
      <div className="w-[280px] min-w-[280px] bg-[#f2f4f9] text-gray-700 p-5 flex flex-col border-r border-[#F2F4F9] h-screen">
        {/* Top section with logo */}
                  <div className="flex items-center justify-center p-4">
                    <img src={gtmLogo} alt="GTM Logo" className="w-10 h-10 mr-3" />
                    <div className="text-center">
                      <h1 className="text-xl font-bold text-gray-800 mb-0">
                        AI EDGAR Document Analysis
                      </h1>
                    </div>
                  </div>        {/* New Chat button */}
        <button
          className="flex items-center justify-center gap-2 p-2.5 bg-white w-[100%] rounded-[18px] cursor-pointer text-sm text-gray-700 hover:bg-white transition-colors"
          onClick={handleHomeClick}
        >
          <img
            src={newChatIcon}
            alt="New Chat"
            className="w-5 h-5 object-contain"
          />
          New Chat
        </button>

        {/* Menu items */}
        <ul className="font-montserrat text-sm font-medium list-none p-0 m-0">
          <li
            onClick={handleHomeClick}
            className="flex items-center gap-2 p-2.5 my-1 cursor-pointer rounded-lg text-gray-600 hover:bg-[#eaecf1] transition-colors font-semibold"
          >
            <img src={homeIcon} alt="Home" className="w-5 h-5" />
            Home
          </li>
          <li
            onClick={handleKnowledgeBaseClick}
            className="flex items-center gap-2 p-2.5 my-1 cursor-pointer rounded-lg text-gray-600 hover:bg-[#eaecf1] transition-colors font-semibold"
          >
            <img src={bookIcon} alt="Knowledge Base" className="w-5 h-5" />
            Knowledge Base
          </li>
          <li className="flex items-center gap-2 p-2.5 my-1 cursor-pointer rounded-lg text-gray-600 hover:bg-[#eaecf1] transition-colors font-semibold">
            <img src={historyIcon} alt="History" className="w-5 h-5" />
            History
          </li>
        </ul>

        <div className="flex flex-col flex-1 mt-10 ml-2 overflow-hidden">
          <h3 className="font-montserrat text-[16px] font-[600] text-gray-600 mb-3">
            Today
          </h3>
          <div className="flex-1 overflow-y-auto scrollbar-hide">
            <ul className="font-montserrat list-none p-0 m-0">
              {/* {messages.map((msg: any, index: any) => (
                <li key={index} className="p-2 text-gray-500 text-sm cursor-pointer rounded hover:bg-gray-100">
                  {msg && msg.length > 20 
                    ? `${msg.substring(0, 20)}...` 
                    : msg}
                </li>
              ))} */}
              {Object.entries(messages).map(([thread, threadMessages]) => (
                <li
                  key={thread}
                  onClick={() => handleThreadSelect(Number(thread))}
                  className="p-2 text-gray-500 text-sm cursor-pointer rounded hover:bg-gray-100"
                >
                  {threadMessages[0]?.text.length > 20
                    ? `${threadMessages[0]?.text.substring(0, 20)}...`
                    : threadMessages[0]?.text}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="shrink-0">
          <a
            href="https://genaienable.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1 pb-2 hover:opacity-80"
          >
            <img
              src={gtmLogo}
              alt="Global Tax Management"
              className="w-[52px] h-[52px]"
            />
            <span className="text-[17px] font-bold text-gray-700">
              GLOBAL TAX MANAGEMENT
            </span>
          </a>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex flex-col w-full">
        <div className="flex-grow overflow-hidden">
          {activeComponent === "chat" ? (
            <ChildComponent
              newChat={newChat}
              updateNewChatValue={updateNewChatValue}
              messagesOfSelectedThread={messagesOfSelectedThread}
              setHistory={setMessages}
              threadId={threadId}
              selectedThread={selectedThread}
            />
          ) : (
            <UploadFiles />
          )}
        </div>
        <div className="flex justify-center mb-2 gap-1">
          <div>
            <CopyRightIcon />
          </div>
          <h5 className="text-[12px] font-[350] text-[#5D5F62] align-text-top">
            Powered By:{" "}
            <a
              href="https://genaienable.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#5D5F62] hover:underline"
            >
              Gen AI Enable
            </a>
          </h5>
        </div>
      </div>

      {/* <LoginPopup
        isOpen={isLoginPopupOpen}
        onClose={() => setIsLoginPopupOpen(false)}
        onSuccess={handleLoginSuccess}
      /> */}
    </div>
  );
};

export default ParentComponent;
